import { ResourceList } from '~/components/list/Resource.interfaces'

export default function useGoToResourceLink() {
  const localePath = useLocalePath()
  const goToResource = (resource: ResourceList | ResourceCard) => {
    switch (resource.type?.toLowerCase()) {
      case 'collection':
        return localePath(`/collection/${resource.slug}/`)
      case 'article':
        return resource.slug
      case 'partition':
      case 'program':
      case 'monographie':
      case 'cd':
      case 'n-periodique':
      case 'thesis':
      case 'livre':
      case 'congres':
      case 'film':
      case 'catalog':
      case 'cd-rom':
      case 'documentary':
      case 'periodique':
      case 'press':
      case 'vinyl':
      case 'flora-article':
      case 'book':
        return localePath(`/flora/${resource.slug}/`)
      case 'author':
        return localePath(`/author/${resource.slug}/articles`)
      case 'biography':
        return localePath(
          `/composer/${resource.slug.replace('biography-', '')}/biography`
        )
      case 'composer':
        if (resource.page === 'advanced_search') {
          return localePath(`/composer/${resource.slug}/biography`)
        } else {
          return localePath(`/search_result?search=${resource.title}`)
        }
      case 'composer-audio':
        return localePath(`/composer/${resource.slug}/audios`)
      case 'composer-video':
        return localePath(`/composer/${resource.slug}/videos`)
      case 'workcourse':
        return localePath(
          `/composer/${resource.slug.replace('workcourse-', '')}/workcourse`
        )
      case 'worklist':
        return `/composer/${resource.slug}/worksByDate`
      case 'analysis':
        return localePath(`/analysis/${resource.slug}/`)
      case 'video':
      case 'audio':
        return localePath(`/media/${resource.slug}/`)
      case 'event':
        return localePath(`/event/${resource.slug}/`)
      case 'work':
        return localePath(`/work/${resource.slug}/`)
      case 'sidney':
        return localePath(`/sidney/${resource.slug}/`)
    }
  }
  return {
    goToResource,
  }
}
